import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import { SECONDARY_REGEX } from 'common-constants/validation';
import { TextField } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const InputAddressSecondary = ({ prefill }) => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name="secondary"
      control={control}
      defaultValue={prefill}
      rules={{
        pattern: {
          value: SECONDARY_REGEX,
          message: 'Please enter a valid apt, suite, unit, or secondary address',
        },
      }}
    >
      <TextField fullWidth label="Apt, suite, unit..." />
    </ValidatedTextField>
  );
};

export default InputAddressSecondary;
